// extracted by mini-css-extract-plugin
module.exports = {"specialPrice":"price_specialPrice__PfgI5 font-sans font-sm leading-5 text-paragraph line-through ml-1"};